import { correctionFilter, CorrectionFilterModel } from './correctionFilter';
import { dashboardFilterModel, DashboardFilterModel } from './dashboardFilter';
import { featuresModel, FeaturesModel } from './features';
import { localeModel, LocaleModel } from './locale';
import { NotificationsModel, notificationsModel } from './notifications';
import studentModel, { StudentModel } from './student';
import {
    UserImpersonationModel,
    userImpersonationModel,
} from './userImpersonation';
import { userModeModel, UserModeModel } from './userMode';

export interface StoreModel {
    dashboardFilter: DashboardFilterModel;
    correctionFilter: CorrectionFilterModel;
    features: FeaturesModel;
    locale: LocaleModel;
    notifications: NotificationsModel;
    student: StudentModel;
    userImpersonation: UserImpersonationModel;
    userMode: UserModeModel;
}

const storeModel: StoreModel = {
    dashboardFilter: dashboardFilterModel,
    correctionFilter: correctionFilter,
    features: featuresModel,
    locale: localeModel,
    notifications: notificationsModel,
    student: studentModel,
    userImpersonation: userImpersonationModel,
    userMode: userModeModel,
};

export default storeModel;
